import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

const DeviceForm = () => {
    const [name, setName] = useState('');
    const [identifier, setIdentifier] = useState('');
    const [activationDate, setActivationDate] = useState('');
    const [deviceType, setDeviceType] = useState('producer'); // Domyślnie "producer"
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { deviceId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await api.get('/users/');
                setUsers(response.data);
            } catch (error) {
                console.error('Failed to fetch users', error);
            }
        };

        fetchUsers();

        if (deviceId) {
            const fetchDevice = async () => {
                try {
                    const response = await api.get(`/devices/${deviceId}`);
                    setName(response.data.name);
                    setIdentifier(response.data.identifier);
                    setActivationDate(response.data.activation_date);
                    setSelectedUserId(response.data.user_id);
                    setDeviceType(response.data.device_type || 'producer');
                } catch (error) {
                    console.error('Failed to fetch device data', error);
                }
            };

            fetchDevice();
        }
    }, [deviceId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Walidacja identyfikatora: tylko przy tworzeniu (w edycji pole jest readonly)
        if (!deviceId) {
            const identifierRegex = /^\d{18}$/;
            if (!identifierRegex.test(identifier)) {
                setErrorMessage('Identyfikator musi zawierać dokładnie 18 cyfr.');
                return;
            }
        }

        setErrorMessage('');

        try {
            if (deviceId) {
                await api.put(`/devices/${deviceId}`, {
                    name,
                    user_id: selectedUserId,
                    device_type: deviceType,
                });
            } else {
                await api.post(`/devices/?user_id=${selectedUserId}`, {
                    name,
                    identifier,
                    activation_date: activationDate,
                    device_type: deviceType,
                });
            }
            navigate('/admin/devices');
        } catch (error) {
            console.error('Failed to save device', error);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full">
                <h2 className="text-2xl font-bold mb-6">
                    {deviceId ? 'Edytuj PPE' : 'Dodaj PPE'}
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Nazwa:</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Identyfikator:</label>
                        <input
                            type="text"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                            required={!deviceId}
                            disabled={!!deviceId}
                            pattern="\d{18}"
                            title="Identyfikator musi zawierać dokładnie 18 cyfr."
                        />
                        {errorMessage && (
                            <p className="text-red-500 mt-1">{errorMessage}</p>
                        )}
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Data aktywacji:</label>
                        <input
                            type="date"
                            value={activationDate}
                            onChange={(e) => setActivationDate(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                            required={!deviceId}
                            disabled={!!deviceId}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Typ urządzenia:</label>
                        <select
                            value={deviceType}
                            onChange={(e) => setDeviceType(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                            required
                        >
                            <option value="">Wybierz typ urządzenia</option>
                            <option value="producer">Producent</option>
                            <option value="consumer">Konsument</option>
                            <option value="prosumer">Prosument</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Użytkownik:</label>
                        <select
                            value={selectedUserId}
                            onChange={(e) => setSelectedUserId(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                            required
                        >
                            <option value="">Wybierz użytkownika</option>
                            {users.map((user) => (
                                <option key={user.id} value={user.id}>
                                    {user.username}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="flex gap-3">
                        <button
                            type="button"
                            onClick={() => navigate('/admin/devices')}
                            className="flex-1 bg-gray-300 text-gray-700 p-2 rounded-lg hover:bg-gray-400 transition"
                        >
                            Anuluj
                        </button>
                        <button
                            type="submit"
                            className="flex-1 bg-softTeal text-white p-2 rounded-lg hover:bg-warmOrange transition"
                        >
                            {deviceId ? 'Zaktualizuj PPE' : 'Dodaj PPE'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeviceForm;
